var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationFamilienrecht(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1262.3 1009.9",
    style: {
      enableBackground: "new 0 0 1262.3 1009.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4F4F4;}\n\t.st1{fill:#137F7B;}\n\t.st2{opacity:0.2;enable-background:new    ;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:none;stroke:#B2B6BB;stroke-width:2.53;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#3F4249;stroke-width:1.2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st6{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n\t.st7{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\n\t.st8{fill:none;stroke:#000000;}\n\t.st9{fill:none;stroke:#FFFFFF;stroke-width:2.72;stroke-miterlimit:10;}\n\t.st10{fill:#DDDDDD;}\n\t.st11{fill:#DADDDF;}\n\t.st12{fill:#21252B;}\n\t.st13{fill:#FC9D9D;}\n\t.st14{opacity:0.15;enable-background:new    ;}\n\t.st15{fill:#3F4249;}\n\t.st16{opacity:0.3;}\n\t.st17{opacity:0.3;enable-background:new    ;}\n\t.st18{opacity:0.1;enable-background:new    ;}\n\t\n\t\t.st19{opacity:0.15;fill:none;stroke:#000000;stroke-width:1.09;stroke-linecap:round;stroke-miterlimit:10;enable-background:new    ;}\n\t.st20{opacity:0.15;}\n\t.st21{fill:none;stroke:#21252B;stroke-width:0.93;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st22{fill:#868A91;}\n\t.st23{fill:#61656D;}\n\t.st24{fill:none;stroke:#61656D;stroke-width:0.75;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st25{fill:none;stroke:#61656D;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st26{fill:none;stroke:#61656D;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st27{opacity:0.4;enable-background:new    ;}\n\t.st28{opacity:0.15;fill:#FFFFFF;enable-background:new    ;}\n\t.st29{fill:#001B34;}\n\t.st30{opacity:0.1;fill:none;stroke:#000000;stroke-linecap:round;stroke-miterlimit:10;enable-background:new    ;}\n\t.st31{fill:#AFB3B8;}\n\t.st32{fill:#D7DADC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2_00000124148144132762057510000007455652862223589043_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 658.2,
    cy: 893.1,
    rx: 448,
    ry: 78.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M887.4,550.9l-33-31H345.6l-23.2,31H887.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M887.4,550.9l-33-31H345.6l-23.2,31H887.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M887.2,550.9H327.5v340.6h559.8L887.2,550.9L887.2,550.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M887.2,550.9H327.5v340.6h559.8L887.2,550.9L887.2,550.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M862,178.9H343.6v602H862L862,178.9L862,178.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M838.7,206H366.9v548h471.9V206H838.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M433.1,308c7.1,0,10.7-0.4,14.2,0.1c3.5,0.4,7,2.2,14.1,2.2s10.5-2.5,14-2.9s7.2,0.5,14.3,0.5 c4.7-0.1,9.4,0.1,14.1,0.6c3.5,0.4,7.1,2,14.2,2c4.8,0,9.5-0.3,14.3-1c4.6-0.7,9.3-1.1,14-1.1c7.1,0,10.7-0.9,14.2-0.4 c3.5,0.4,7,1.4,14.1,1.4c4.7,0,9.5-0.3,14.2-0.9s9.4-0.9,14.1-0.8c4.7,0,9.4,0.3,14.1,1c3.5,0.4,7.1-0.5,14.2-0.5 s10.6,0.8,14.1,0.3c3.5-0.4,7.1-2.1,14.1-2.1c7.1,0,10.8-0.1,14.4,0.4c3.5,0.4,6.9,2,13.9,2s10.7,0.7,14.2,0.2 c4.7-0.6,9.4-0.9,14.1-0.9c7.1,0,10.6-0.1,14.1,0.3s7.1,2.2,14.1,2.2c4.8,0,9.6-0.3,14.3-1c3.5-0.4,6.9-2.2,14-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M586.3,337.4c7.8,0,7.8,1.8,15.5,1.8c7.8,0,7.8-1.3,15.5-1.3c7.8,0,7.8,1.6,15.5,1.6c7.8,0,7.8-1.8,15.6-1.8 s7.8,2.7,15.5,2.7s7.8-2.2,15.6-2.2s7.8,2.4,15.5,2.4c7.8,0,7.8-3.2,15.5-3.2c7.8,0,7.8,2.7,15.6,2.7s7.8-2.6,15.6-2.6 s7.8,3.1,15.6,3.1s7.8-3.3,15.6-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M433.5,338.1c4.7,0,4.7,2.1,9.3,2.1c4.7,0,4.7-2.2,9.3-2.2s4.7,2,9.3,2c4.7,0,4.7-1.4,9.3-1.4s4.7,1.5,9.3,1.5 c4.7,0,4.7-1.9,9.3-1.9c4.7,0,4.7,1.3,9.3,1.3s4.7-1.4,9.3-1.4c4.7,0,4.7,1.1,9.4,1.1s4.7-1.6,9.3-1.6c4.7,0,4.7,2.4,9.4,2.4 s4.7-2.1,9.3-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M500.7,367.4c5.7,0,8.4,2.1,11.3,2.5c2.8,0.4,5.8-1,11.5-1s8.7,2,11.5,1.6s5.5-2.3,11.2-2.3 c3.8-0.1,7.6,0.2,11.4,0.7c2.8,0.4,5.6-0.1,11.3-0.1s8.6,1.6,11.5,1.2c2.8-0.4,5.6-2.4,11.2-2.4c5.7,0,8.5,1.1,11.4,1.5 c2.8,0.4,5.7-0.3,11.3-0.3s8.5,1,11.4,0.6s5.7-1.9,11.3-1.9c5.7,0,8.4,1.9,11.3,2.3c3.8,0.7,7.6,1.1,11.4,1.1c5.7,0,8.4-2,11.2-2.4 c3.8-0.7,7.6-1,11.5-1c5.7,0,8.4,2.2,11.2,2.6c3.8,0.5,7.6,0.7,11.5,0.6c5.7,0,8.5-1,11.4-1.4c3.7-0.8,7.5-1.2,11.3-1.2 c3.8-0.1,7.7,0.1,11.5,0.5c3.7,0.5,7.5,0.7,11.3,0.5c5.7,0,8.3-0.9,11.2-1.3c2.8-0.4,5.9,1.5,11.6,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M434,368.6c4.2,0,4.2,1.4,8.5,1.4s4.2-1.7,8.5-1.7s4.2,1.9,8.5,1.9c4.2,0,4.2-1.9,8.5-1.9s4.2,1.7,8.5,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M679.6,399.1c6.7,0,6.7,1.9,13.4,1.9s6.7-1.7,13.4-1.7s6.7,0.8,13.5,0.8c6.7,0,6.7-1.4,13.5-1.4 s6.7,1.9,13.5,1.9c6.7,0,6.7-1.3,13.4-1.3s6.7,1.5,13.5,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M551.7,399.4c7.8,0,7.8,1,15.6,1s7.8-1.3,15.5-1.3c7.8,0,7.8,1.2,15.5,1.2s7.8-1.8,15.6-1.8s7.8,1.9,15.6,1.9 s7.8-1.8,15.6-1.8s7.8,1.4,15.6,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M434.4,398.8c6.1,0,6.1,1.7,12.2,1.7c6.1,0,6.1-1.2,12.2-1.2s6.1,1.1,12.2,1.1s6.1-1.3,12.2-1.3 s6.1,1.3,12.2,1.3s6.1-1.9,12.2-1.9c6.1,0,6.1,2.4,12.3,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M434.8,428.5c7.1,0,10.5,1.9,14.1,2.3c3.5,0.4,7.2-0.4,14.2-0.4c7.1,0,10.7,0.8,14.2,0.4 c3.5-0.4,7-1.4,14.1-1.4s10.5,1.4,14,1.8c3.5,0.4,7.2-0.4,14.3-0.4s10.4-1.8,14-2.2s7.2,1.4,14.3,1.4s10.5,1,14,1.4 c3.6,0.4,7.2-1.2,14.3-1.2s10.4-1,14-1.5s7.2,0.3,14.3,0.3c4.7,0,9.5,0.4,14.1,1.2c3.5,0.4,7.1,0.1,14.1,0.1s10.7,1.1,14.2,0.6 c3.5-0.4,7-1.3,14-1.3c4.7,0,9.4,0.3,14.1,1c4.7,0.8,9.4,1.2,14.2,1.3c7.1,0,10.5-1.7,14.1-2.2c4.7-0.8,9.4-1.2,14.2-1.2 c4.8-0.1,9.5,0,14.3,0.4c3.5,0.4,6.9,2.7,14,2.7s10.4-2.5,14-2.9s7.2,2.2,14.3,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M435.6,461.2c7.1,0,10.6-1.3,14.2-0.9c3.5,0.4,7,1.4,14.1,1.4s10.5-2.1,14-2.5s7.2-0.4,14.3-0.4 s10.5,2.5,14,2.9c4.7,0.8,9.5,1.2,14.3,1.2c7.1,0,10.6-2.2,14.1-2.6c4.7-0.6,9.4-0.8,14.1-0.7c7.1,0,10.5,1.2,14.1,1.6 c3.5,0.4,7.2,0,14.2,0s10.6,0.1,14.2-0.4c3.5-0.4,7-0.2,14.1-0.2s10.8-1.8,14.3-1.3c3.5,0.4,6.9,1.9,14,1.9 c4.7-0.1,9.4-0.5,14.1-1.3c4.7-0.8,9.4-1.2,14.2-1.3s9.5,0.2,14.3,0.7c3.5,0.4,6.9,3.3,14,3.3s10.7-1.2,14.2-1.6 c4.7-0.6,9.4-0.8,14.1-0.7c7.1,0,10.7-1.4,14.3-1c3.5,0.4,6.9,3.4,14,3.4s10.6-1.7,14.2-2.1c3.5-0.4,7-1.7,14.1-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M588.8,490.8c7.8,0,7.8,0.6,15.5,0.6s7.8-0.7,15.5-0.7s7.8,0.6,15.6,0.6s7.8-0.6,15.5-0.6 c7.8,0,7.8,1.7,15.5,1.7c7.8,0,7.8-2.9,15.6-2.9s7.8,2.2,15.5,2.2s7.8-0.9,15.5-0.9s7.8,0.3,15.6,0.3s7.8-0.7,15.6-0.7 s7.8,1.7,15.5,1.7c7.8,0,7.8-1.9,15.6-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M436.1,489.6c4.7,0,4.7,2.6,9.3,2.6s4.7-2.4,9.3-2.4c4.7,0,4.7,1.7,9.3,1.7s4.7-1,9.3-1c4.7,0,4.7,0.9,9.3,0.9 s4.7-1.8,9.3-1.8c4.7,0,4.7,2,9.3,2s4.7-2,9.4-2c4.7,0,4.7,1.8,9.3,1.8s4.7-1.4,9.3-1.4c4.7,0,4.7,2,9.3,2s4.7-1.7,9.4-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M503.2,519.6c3.8,0,7.7,0.4,11.5,1c3.7,0.5,7.5,0.7,11.3,0.7c5.7,0,8.6,0.9,11.4,0.5c3.7-0.7,7.5-1.1,11.3-1.1 c5.7,0,8.3,1.4,11.2,1.8c3.8,0.5,7.7,0.8,11.5,0.7c3.9,0.1,7.7-0.1,11.5-0.5c2.8-0.4,5.5-2.2,11.2-2.2s8.4,1.2,11.2,1.6 c2.8,0.4,5.8,0.2,11.5,0.2s8.6,0.2,11.5-0.3c2.8-0.4,5.6-2.1,11.2-2.1c3.8,0,7.7,0.3,11.4,1c2.8,0.4,5.6,2,11.3,2s8.5-1,11.4-1.4 c2.8-0.4,5.7,0.3,11.3,0.3c3.7-0.1,7.5,0,11.2,0.5c3.8,0.6,7.7,0.9,11.5,0.8c5.7,0,8.5-1.6,11.3-2c3.8-0.6,7.6-0.8,11.4-0.7 c5.7,0,8.7-0.3,11.5,0.1c2.8,0.4,5.6,1.9,11.2,1.9c3.8,0,7.6-0.3,11.4-1c2.8-0.4,5.7,0.5,11.4,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M436.5,520.2c5.3,0,5.3,1.7,10.6,1.7s5.3-1.6,10.6-1.6s5.3,1.8,10.6,1.8s5.3-1.7,10.6-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M682.2,551.2c6.7,0,6.7,1.4,13.4,1.4s6.7-1.8,13.5-1.8s6.7,1.3,13.5,1.3s6.7-1.5,13.5-1.5 c6.7,0,6.7,1.8,13.5,1.8c6.7,0,6.7-1.6,13.5-1.6s6.7,1.5,13.5,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M554.3,550.4c7.8,0,7.8,2.3,15.6,2.3s7.8-1.3,15.6-1.3s7.8,0.7,15.5,0.7c7.8,0,7.8-0.9,15.6-0.9 s7.8,1.5,15.5,1.5c7.8,0,7.8-1.8,15.6-1.8s7.8,2.2,15.6,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M436.9,551.2c6.1,0,6.1,1.3,12.2,1.3c6.1,0,6.1-1.8,12.2-1.8c6.1,0,6.1,1.9,12.2,1.9s6.1-1.9,12.2-1.9 s6.1,1.6,12.2,1.6s6.1-1.3,12.3-1.3c6.1,0,6.1,1.8,12.2,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M437.3,582c7.1,0,10.4,0.9,14,1.4c4.7,0.7,9.5,1,14.3,1s9.6-0.3,14.3-1c3.5-0.4,6.9-3.1,14-3.1 s10.7,1,14.2,1.4c3.5,0.5,7-0.2,14.1-0.2s10.5,0.4,14.1,0c3.5-0.4,7.1,0.5,14.2,0.5c4.7,0,9.4,0.2,14.1,0.8 c3.5,0.4,7.1-0.7,14.2-0.7c4.7,0,9.4-0.3,14-1c4.7-0.6,9.5-0.8,14.3-0.7c7.1,0,10.6,1.2,14.2,1.6c3.5,0.4,7,2.4,14.1,2.4 s10.4-3.3,14-3.7s7.3,0.4,14.3,0.4c7.1,0,10.5,2,14,2.4s7.2-0.1,14.3-0.1s10.7,0.1,14.2-0.3c4.7-0.4,9.3-0.6,14-0.4 c7.1,0,10.5-0.2,14.1,0.2c3.5,0.4,7.2,1.7,14.2,1.7c7.1,0,10.5-2.6,14.1-3c3.5-0.4,7.2-1.7,14.2-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M438.2,612.9c7.1,0,10.6-0.8,14.1-0.4c3.5,0.4,7.1-0.1,14.1-0.1s10.6,0.2,14.1-0.2s7.1-0.2,14.2-0.2 s10.8-1,14.3-0.6c3.5,0.4,6.9,1.6,14,1.6s10.5-0.9,14-1.3c3.5-0.4,7.2,0.7,14.2,0.7s10.6-0.2,14.1,0.2s7.1,1.6,14.1,1.6 c4.8,0,9.5-0.3,14.2-1c3.5-0.4,7-2.9,14.1-2.9s10.5,2.8,14,3.2c4.7,0.6,9.5,0.9,14.2,0.9c7.1,0,10.5-2.7,14-3.1 c3.6-0.4,7.3,1.7,14.3,1.7s10.7-1.2,14.2-0.8s7,2.3,14.1,2.3s10.6-1.4,14.2-1.8c4.7-0.6,9.4-0.9,14.1-0.8c4.7,0,9.4,0.4,14.1,1.2 c3.5,0.4,7.1,1.5,14.2,1.5s10.6-1.3,14.2-1.7c4.7-0.7,9.4-1.1,14.1-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M438.6,642.2c4.7,0,4.7,1.7,9.3,1.7s4.7-1.8,9.3-1.8s4.7,1.9,9.3,1.9s4.7-1.8,9.3-1.8c4.7,0,4.7,1.8,9.3,1.8 s4.7-2.5,9.3-2.5c4.7,0,4.7,1.6,9.3,1.6s4.7-1.2,9.3-1.2c4.7,0,4.7,1.4,9.3,1.4s4.7-1.9,9.3-1.9c4.7,0,4.7,1.8,9.4,1.8 s4.7-0.9,9.3-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M329,893.1l280.3-201.2l279.5,201.2H329z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M329.4,892.4l279.8-201.6l279.2,202.1L329.4,892.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M886.8,554.2L626,733.5l260.8,156.8L886.8,554.2L886.8,554.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M886.8,890.3v-336L626,733.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M886.8,890.3v-336L626,733.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.5,554.2l260.8,179.2L327.5,890.2L327.5,554.2L327.5,554.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.5,890.3v-336l260.8,179.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M327.5,890.3v-336l260.8,179.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M606.9,790.9c28.6,0,51.8-23.2,51.8-51.8s-23.2-51.8-51.8-51.8s-51.8,23.2-51.8,51.8S578.3,790.9,606.9,790.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M658.2,739.1c0,28.3-23,51.3-51.3,51.3s-51.3-23-51.3-51.3s22.9-51.3,51.3-51.3S658.2,710.8,658.2,739.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M661.4,739.1c0,5.6-6.2,10.1-7.8,15.2c-1.7,5.2,0.6,12.5-2.6,16.9c-3.2,4.3-10.9,4.5-15.3,7.7 s-6.8,10.5-12,12.2c-5,1.6-11.3-2.8-16.8-2.8c-5.6,0-11.8,4.4-16.8,2.8c-5.2-1.7-7.6-9-12-12.2s-12.1-3.3-15.3-7.7 s-0.9-11.6-2.6-16.9c-1.6-5-7.8-9.6-7.8-15.2c0-5.6,6.2-10.1,7.8-15.2c1.7-5.2-0.6-12.5,2.6-16.9s10.9-4.5,15.3-7.7 s6.8-10.5,12-12.2c5-1.6,11.2,2.8,16.8,2.8s11.8-4.4,16.8-2.8c5.2,1.7,7.6,9,12,12.2s12.1,3.3,15.3,7.7s0.9,11.7,2.6,16.9 C655.2,729,661.4,733.5,661.4,739.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M606.9,783.7c24.6,0,44.6-20,44.6-44.6s-20-44.6-44.6-44.6s-44.6,20-44.6,44.6 C562.3,763.8,582.3,783.7,606.9,783.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.9,163.3v117.1H253V163.3H103.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M118.9,178.9v86H238V179L118.9,178.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M256.3,163.4h-3.4v117h3.4V163.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.6,226.3c3.7,0,7.3-1.1,10.3-3.1c3.1-2,5.4-4.9,6.9-8.3c1.4-3.4,1.8-7.1,1.1-10.7s-2.5-6.9-5.1-9.5 s-5.9-4.4-9.5-5.1s-7.3-0.3-10.7,1.1c-3.4,1.4-6.3,3.8-8.3,6.9s-3.1,6.7-3.1,10.3c0,4.9,2,9.7,5.4,13.2 C170.9,224.3,175.7,226.3,180.6,226.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M131.7,257.3l30.3-19.4l-30-19.3L131.7,257.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M184.7,212v40.2h40.2V212H184.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M279.2,238.5c1.7-2.5,2.5-5.5,2.2-8.5c-0.4-6.5-4.8-11.5-10.1-11.6c-2.6-14-16-24.3-31.5-23.4 c-16.8,0.9-29.6,14.5-28.7,30.2c0.2,3.7,1.2,7.4,2.9,10.7c-5.3,2.5-9.7,6.5-12.6,11.6s-4.1,11-3.5,16.8c0.7,5.6,3,10.8,6.6,15.1 c3.6,4.3,8.5,7.4,13.9,8.9s11.2,1.4,16.5-0.3c5.4-1.7,10.1-5,13.6-9.4c3.3,4.4,8,7.7,13.3,9.4c5.3,1.7,11,1.6,16.2-0.1 c5.3-1.7,9.9-5,13.2-9.5c3.3-4.5,5.1-9.8,5.2-15.4c0-5.4-1.6-10.6-4.7-15C288.6,243.8,284.3,240.4,279.2,238.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M231.3,259.5c0,0,4.2,28.7-1.7,31.2l-8,2.1l5.9,20.3l23.6,12.7l23.6-10.1l2.1-24.9c-2.8-0.4-5.4-1.6-7.6-3.4 c-3.4-4.2-3.4-18.6-3-32.5L231.3,259.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M248.6,269.2l1.5,3.8c-2.6-0.1-6.8-0.7-9.4-2.7c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.2-0.2,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0.1,0.3 c0.1,0.1,0.1,0.2,0.2,0.3c3.6,2.9,9.5,3.2,11.9,3.2c0.5,0,0.9,0,1,0s0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.3-0.2c8.2,2.6,12.6-0.1,13.5,0 l-0.6-8.2L248.6,269.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M251.2,273.4c-5.6,0-11-2.2-14.9-6.2c-4-4-6.2-9.3-6.2-14.9v-38.8h37.1l4.7,36.1c0.4,3,0.2,6-0.6,8.9 c-0.8,2.9-2.3,5.5-4.3,7.8s-4.4,4.1-7.1,5.3C257.2,272.8,254.2,273.4,251.2,273.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M272.3,229.5c0,0-23.2,4.6-33.4-7.2c0,0,2.1,7.2-7.2,13.1c0,0,2.3,5.6,0.5,10.4c-0.1,0.2-0.2,0.3-0.4,0.4 c-0.2,0.1-0.3,0.2-0.5,0.2s-0.4,0-0.5-0.1c-0.2-0.1-0.3-0.2-0.4-0.4l-4.7-10.4v-23.6h42.2L272.3,229.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M335.8,787.4L340,833c0.3,5.3,1.7,8.7,3.2,10.9l16.6,33.7l-4.6,6.3l-18-9l-16-29c0-5-0.5-7.9-1.4-14.5 l-8-49.2L335.8,787.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M340.8,850c-1.8-2.5-4.1-8.6-4.6-11.4l-5.4-16c-0.1-0.6-0.4-1.1-0.8-1.5s-0.9-0.6-1.5-0.7l-10.8-1.4l-0.2-2.3 h21.1l1.8,18.8c0.4,3.2,2.4,7.5,4.3,10.2l15.2,31.9l-2.8,4.4L340.8,850z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.4,883.3l-9.5-5.7c-3.4,0.5-6.8,0.2-10-1s-6-3.2-8.2-5.8l-20.6-24.9c-3.7,7.9-5,16.8-3.8,25.4l3,20.6h2.4 l0.6-21.2c0-0.3,0.1-0.7,0.3-0.9c0.2-0.3,0.5-0.5,0.8-0.6s0.7-0.1,1,0s0.6,0.3,0.8,0.5l12.5,15.3c1.8,2.2,4,3.9,6.5,5.1 s5.3,1.8,8,1.8h19.5c0.4,0,0.7-0.1,1-0.2c0.3-0.2,0.6-0.4,0.8-0.7c0.2-0.3,0.3-0.7,0.3-1c0-0.4-0.1-0.7-0.2-1 C373.8,886.4,371.9,884.4,369.4,883.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.8,841.9c0.9,2.8,1.3,5.8,1.1,8.8l0.1,24.9c-0.1,4.3-1.4,8.6-3.6,12.3l-0.5,0.9c-0.6,1.1-1.6,2-2.7,2.6 s-2.3,0.9-3.6,0.9h-7.3c-1.6,0-3.2-0.5-4.5-1.5s-2.2-2.3-2.6-3.9c-1-3.7-1.1-7.5-0.4-11.2L235,849c0.4-2.5,1.2-4.9,2.2-7.2 L252.8,841.9L252.8,841.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M253.9,830.6c-1.1,9-1.6,18-1.4,27l0.2,10.8c-0.1,2.3-1.1,4.4-2.8,6c-1.7,1.6-3.9,2.4-6.2,2.4h-1.6 c-1.3,0-2.5-0.2-3.7-0.7s-2.2-1.3-3-2.2c-0.8-0.9-1.5-2.1-1.8-3.3c-0.4-1.2-0.5-2.5-0.3-3.8l2.6-12.8c1.3-6.5,1.8-13.1,1.4-19.7 l-2.4-43.5l22.9,0.4L253.9,830.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M255.7,817.4c0,0-2.8,24.9-2.9,28.2v0.1c-0.3,4.7-0.5,9.3-0.4,14.1l0.2,9.6c-0.2,4.1-3.9,7.4-8.5,7.5 c4.2-2.8,3.8-7.5,3.9-10.9l0.7-42.1c0-0.7-0.3-1.4-0.8-1.9s-1.1-0.9-1.8-0.9l-10.2-1.6l-0.1-2L255.7,817.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M315.3,817.1h25.3c0,0-3.6-290-16.1-333.7l-32-29.3h-80.2c0,0-36.3-5.1,22,363h23.6l2.7-306.4 c0-0.8,0.1-1.6,0.4-2.3s0.7-1.4,1.3-2c0.5-0.6,1.2-1,1.9-1.3c0.7-0.3,1.5-0.5,2.3-0.5c1.4,0,2.8,0.5,3.8,1.4c1.1,0.9,1.8,2.2,2,3.6 L315.3,817.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M231,259.4c0,0-11.8-0.5-12.6-11.4c-0.8-10.9,12.4-11.1,13-0.2l0.9,11.8L231,259.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M225.4,291.6c2.7,4,6.4,7.2,10.6,9.4c4.3,2.2,9,3.3,13.8,3.3c0,0,20.3,0,26.2-13.5l3.8,0.4v164.6h-41.3 l-24.9-160L225.4,291.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M222.3,243.5c0.4-0.3,0.9-0.6,1.4-0.7s1-0.2,1.5-0.1s1,0.4,1.4,0.7c0.4,0.3,0.7,0.7,0.9,1.2 c0.7,1.1,1.1,2.4,1.1,3.6v1.1c0,0.8-1.2,1-1.3,0.1v-1.1c-0.1-1.1-0.4-2.1-0.9-3.1c-0.1-0.3-0.4-0.6-0.6-0.8 c-0.3-0.2-0.6-0.4-0.9-0.5c-0.3,0-0.7,0-1,0.1s-0.6,0.3-0.9,0.5c-0.1,0-0.1,0.1-0.2,0.1s-0.2,0-0.2,0c-0.1,0-0.2,0-0.2-0.1 c-0.1,0-0.1-0.1-0.2-0.2C221.9,244,222,243.6,222.3,243.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.4,450.9h-82.8v7.5h82.8V450.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M229.6,494.1c0,0,19.1,3,20.8-26.5c0,0,8.2-71.2-23.2-160.8L229.6,494.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266.4,504.8h-0.8c-7,0-15.2,5.7-15.2,12.7l-2.9,299.7h10.4l2.7-306.4c0-0.8,0.1-1.5,0.4-2.3 c0.3-0.7,0.7-1.4,1.2-1.9c0.5-0.6,1.2-1,1.9-1.3C264.9,504.9,265.6,504.8,266.4,504.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M316.2,490.4c0,0,4.2,26.2,16.4,326.7h8.1c0,0-2.8-268.7-14.7-327.8L316.2,490.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.8,290.7l31.8,4.5c4.2,0.7,8.2,2.2,11.8,4.4c3.6,2.2,6.7,5.2,9.2,8.6c3.1,4.3,6.1,8.7,9.4,12.9l3.4,4.4v47 l-28-25.3c0,0-20.8,78.7,12,141.9c0.1,0.1,0.1,0.3,0.1,0.5s-0.1,0.3-0.1,0.5c-0.1,0.1-0.2,0.3-0.3,0.3c-0.1,0.1-0.3,0.1-0.4,0.2 l-22.6,1c-5,0.2-10-1.3-14.1-4.2c-4.1-3-7-7.3-8.3-12.1C274.3,448.3,260.5,391.2,277.8,290.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.9,292.4l-28.7,10.3c0,0,23.8,103.9,4.1,194.8c0,0.2,0,0.3,0,0.5c0,0.1,0.1,0.3,0.2,0.4 c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.1,0.4,0.1l28.6-4.2c4.7-0.7,9-2.9,12.4-6.3c3.3-3.4,5.4-7.8,5.9-12.6 C249.5,447.4,250.8,386.5,222.9,292.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M245.2,397.7h-2.8c-14-31-22.1-47.7-25.8-55.4c-0.1-0.1-0.8,0-0.7,0.1l22.2,61.3l7.6-0.3L245.2,397.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M248.4,397.8l0.5,5.6l49.5-1.6v-1.7L248.4,397.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M309.4,340.4c0,0-24.2,65.6,6.3,150.5l9.4-0.4l1.8-0.2c0.2-0.1,0.4-0.3,0.5-0.6c0.1-0.2,0.1-0.5,0-0.7 c-32.9-63.1-12-142.3-12-142.3L309.4,340.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M250.1,244.4c0.4,0,0.8-0.1,1.1-0.3c0.3-0.2,0.6-0.5,0.7-0.9c0.2-0.4,0.2-0.8,0.1-1.2s-0.3-0.7-0.5-1 c-0.3-0.3-0.6-0.5-1-0.5c-0.4-0.1-0.8,0-1.2,0.1c-0.4,0.2-0.7,0.4-0.9,0.7c-0.2,0.3-0.3,0.7-0.3,1.1c0,0.5,0.2,1,0.6,1.4 S249.6,244.4,250.1,244.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M250.9,242.3c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3s0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1 c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0.1-0.1,0.2-0.1,0.3s0,0.2,0.1,0.3C250.7,242.3,250.8,242.3,250.9,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M265.9,244.4c0.4,0,0.8-0.1,1.1-0.3c0.3-0.2,0.6-0.5,0.7-0.9c0.2-0.4,0.2-0.8,0.1-1.2c-0.1-0.4-0.3-0.7-0.5-1 c-0.3-0.3-0.6-0.5-1-0.5c-0.4-0.1-0.8,0-1.2,0.1c-0.4,0.2-0.7,0.4-0.9,0.7c-0.2,0.3-0.3,0.7-0.3,1.1c0,0.5,0.2,1,0.6,1.4 S265.4,244.4,265.9,244.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M266.8,242.3c0.1,0,0.2,0,0.2-0.1c0.1,0,0.1-0.1,0.1-0.2s0-0.2,0-0.2l-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1 s-0.2,0-0.2,0c-0.1,0-0.1,0.1-0.2,0.2c0,0.1-0.1,0.1-0.1,0.2s0,0.1,0,0.2s0.1,0.1,0.1,0.1l0.1,0.1 C266.7,242.2,266.8,242.3,266.8,242.3z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M256.6,253.3h-1.8c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2s0-0.2,0-0.2 c0-0.1,0-0.2,0-0.2c0-0.1,0.1-0.1,0.1-0.2s0.1-0.1,0.2-0.1s0.2,0,0.2,0h1.8c0.2,0,0.4,0,0.5-0.1c0.2-0.1,0.3-0.1,0.5-0.3 c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.2,0.1-0.3,0.1-0.5s0-0.4-0.1-0.5c-0.1-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.5-0.3 c-0.2-0.1-0.3-0.1-0.5-0.1s-0.3-0.1-0.4-0.2s-0.2-0.3-0.2-0.4c0-0.2,0.1-0.3,0.2-0.4s0.3-0.2,0.4-0.2c0.3,0,0.7,0,1,0.1 s0.6,0.3,0.8,0.5c0.2,0.2,0.4,0.5,0.6,0.8s0.2,0.6,0.2,1s-0.1,0.7-0.2,1s-0.3,0.6-0.6,0.8c-0.2,0.2-0.5,0.4-0.8,0.5 C257.3,253.3,256.9,253.3,256.6,253.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.8,255c0-0.2,0-0.4-0.1-0.5c-0.1-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.3-0.1-0.5-0.1 c-0.4,0-0.7,0.1-1,0.4s-0.4,0.6-0.4,0.9c0,0.2,0,0.4,0.1,0.5c0.1,0.2,0.2,0.3,0.3,0.4c0.1,0.1,0.3,0.2,0.4,0.3 c0.2,0.1,0.3,0.1,0.5,0.1c0.4,0,0.7-0.1,1-0.4C228.7,255.7,228.8,255.3,228.8,255z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M228,256.1c-0.2,0-0.4,0-0.5-0.1c-0.2-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.3-0.3-0.5 c-0.1-0.2-0.1-0.4-0.1-0.5c0-0.3,0.1-0.5,0.2-0.8c-0.2,0.1-0.3,0.3-0.4,0.5s-0.1,0.4-0.1,0.6s0,0.4,0.1,0.5 c0.1,0.2,0.2,0.3,0.3,0.4c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6-0.1,0.8-0.2H228z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M260.6,258.6c0.1,0,0.1,0,0.2,0s0.1,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2s0,0.1,0,0.2c-0.5,1-1.2,1.8-2.1,2.4 s-2,0.9-3.1,0.9c-1.1,0-2.2-0.3-3.1-0.9s-1.7-1.4-2.1-2.4c-0.1-0.2,0-0.5,0.3-0.5L260.6,258.6L260.6,258.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M265.4,235.4c-1.2,0.1-2.4,0.5-3.5,1.1s-2,1.5-2.7,2.5c-1.7-0.6-3.4-0.6-5.1,0c-0.8-1.3-1.9-2.4-3.3-3 s-2.9-1-4.4-0.8c-1.6,0.1-3.2,0.7-4.4,1.7c-1.3,1-2.2,2.4-2.7,3.9s-0.5,3.2-0.1,4.8c0.4,1.6,1.3,3,2.6,4c1.2,1.1,2.8,1.7,4.4,1.9 c1.6,0.2,3.3-0.1,4.7-0.8s2.6-1.9,3.4-3.3s1.1-3,1-4.7c-0.1-0.9-0.3-1.8-0.7-2.6c1.3-0.5,2.8-0.5,4.1-0.1c-0.6,1.1-0.9,2.4-0.9,3.7 c0,1.3,0.3,2.5,0.8,3.7c0.6,1.1,1.4,2.1,2.4,2.9s2.2,1.3,3.4,1.5c1.2,0.2,2.5,0.2,3.8-0.1c1.2-0.3,2.3-1,3.3-1.8 c0.9-0.8,1.7-1.9,2.1-3.1c0.5-1.2,0.7-2.4,0.6-3.7c-0.1-1.1-0.4-2.1-0.8-3.1c-0.5-1-1.2-1.8-2-2.6c-0.8-0.7-1.8-1.2-2.8-1.6 C267.6,235.4,266.5,235.3,265.4,235.4z M247.8,250.4c-1.4,0.1-2.8-0.2-4.1-0.9c-1.2-0.7-2.3-1.7-2.9-3s-0.9-2.7-0.7-4.1 c0.2-1.4,0.7-2.7,1.7-3.8c0.9-1.1,2.1-1.9,3.5-2.3s2.8-0.4,4.2,0.1c1.4,0.4,2.6,1.3,3.4,2.4s1.4,2.5,1.5,3.9 c0.2,1.9-0.5,3.8-1.7,5.2C251.5,249.3,249.7,250.3,247.8,250.4L247.8,250.4z M266.7,250.7c-1.4,0.1-2.8-0.2-4.1-0.9 c-1.2-0.7-2.2-1.8-2.9-3c-0.6-1.3-0.9-2.7-0.7-4.1c0.2-1.4,0.8-2.7,1.7-3.8c0.9-1.1,2.2-1.9,3.5-2.2c1.4-0.4,2.8-0.4,4.2,0.1 c1.4,0.4,2.5,1.3,3.4,2.4s1.4,2.5,1.5,3.9c0.1,0.9,0,1.9-0.3,2.8s-0.8,1.7-1.4,2.5c-0.6,0.7-1.4,1.3-2.2,1.7 C268.6,250.3,267.7,250.6,266.7,250.7L266.7,250.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M330.9,398.6l12.5-9.9l-0.1,4l-1,4.4L330.9,398.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M330.9,398.6l12.5-9.9l-0.1,4l-1,4.4L330.9,398.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M292.5,423.8l0.4-22.3l28.8,0.1c1.1,0,2.2-0.3,3.2-0.8l1.4-0.7c0.4-0.1,0.7-0.2,1-0.4l15.5-7.1 c1.6-0.8,3.4-1.4,5.2-1.6l21.2-2.8c0.4-0.1,0.9,0,1.2,0.3c0.4,0.2,0.6,0.6,0.7,1c0.1,0.5,0,0.9-0.3,1.3c-0.3,0.4-0.7,0.7-1.1,0.8 l-19.5,4.4l20.7,0.3c0.2,0,0.5,0,0.7,0.1s0.4,0.2,0.6,0.4c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.1,0.5,0.1,0.7c0,0.5-0.2,0.9-0.6,1.3 c-0.3,0.3-0.8,0.6-1.2,0.6l-19.9,2.1l17.9-1.9c0.2,0,0.5,0,0.7,0c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.1,0.3,0.3,0.4,0.5 c0.1,0.2,0.2,0.4,0.2,0.7c0,0.5-0.1,1-0.4,1.3c-0.3,0.4-0.7,0.7-1.2,0.8l-17.4,3.8l14.9-3.2c0.2,0,0.4-0.1,0.6,0 c0.2,0,0.4,0.1,0.5,0.2c0.2,0.1,0.3,0.2,0.4,0.4c0.1,0.2,0.2,0.3,0.2,0.5s0.1,0.4,0,0.6c0,0.2-0.1,0.4-0.2,0.5 c-0.1,0.2-0.2,0.3-0.4,0.4c-0.2,0.1-0.3,0.2-0.5,0.2l-19.5,4c0,0.4,0,0,0,0c-9.7,3.2-19.7,4.2-23.8,5.4c-1.9,0.5-3.8,1.1-5.8,1.6 L292.5,423.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M369.1,399.7l-17.2,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M351.3,405.9l15.5-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M368.4,406.5c0-0.1-0.1-0.2-0.1-0.3l-15.7,2.2l-26.8,4.4l-33.2,7.5l-0.1,3.5l26.6-5.7c2-0.4,3.9-1,5.9-1.6 c4.3-1.2,14.5-2.5,24.4-5.7l17.9-3.4C368.1,407.2,368.6,407.3,368.4,406.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.2,296.6l-17,6.3c-13.8,5.2-20.8,19.7-15.8,32.8l41.4,85.9c2.7,6.9,10.3,11.1,18.1,9.9l61.7-8.7l-0.2-22 h-58c0,0-7.5-17.7-24-56c-1.3-3.6-5-11.2-5.3-14.9C210.1,318.9,211.2,307.5,210.2,296.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M205.4,390.7l13.2,30.9c2.7,6.9,10.3,11.1,18,9.9l61.8-8.7v-4.1l-49,7c-8,1.2-11.9,2.2-15.9,2 c-2.5-0.1-4.9-0.8-7-2.1s-3.9-3.2-5-5.4L205.4,390.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M231.7,262.4l1.7-3.7c-0.7,0.3-1.4,0.6-2.1,0.8L231.7,262.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M112,673.4l-7.2,177.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M59.9,750.5l31.9,37.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M134.1,794.9l-28.7,43.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M148,721.8L108.5,767"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.4,746c9.4-11,12.2-24,6.3-29c-5.9-5-18.3-0.1-27.6,10.9s-12.2,24-6.3,29C123.6,761.9,136,757,145.4,746z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M152.1,717.5l-34.5,39.3c0.1,0,0.1,0.1,0.2,0.1c5.9,5,18.3,0.1,27.6-10.8 C154.6,735.3,157.5,722.7,152.1,717.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79,772.5c4.5-3.8,2.5-13.8-4.6-22.3c-7.1-8.6-16.5-12.5-21.1-8.7s-2.5,13.8,4.6,22.3 C65,772.4,74.4,776.3,79,772.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M53,741.8l26.1,30.6l-0.1,0.1c-4.5,3.8-14-0.1-21.2-8.7C51,755.5,48.8,745.7,53,741.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M64.7,801.2l33.6,26.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.8,818.9c3.7-4.6-0.4-14-9-20.9s-18.7-8.8-22.4-4.2s0.4,14,9,20.9C74.1,821.6,84.1,823.5,87.8,818.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M56.1,794.1l31.7,24.7l-0.1,0.1c-3.6,4.7-13.7,2.8-22.4-4.2C56.9,808,52.9,798.8,56.1,794.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.2,686.7c0.7-14.5-4.9-26.4-12.5-26.8c-7.6-0.4-14.2,11.1-14.9,25.5s4.9,26.4,12.5,26.8 C117.8,712.6,124.5,701.2,125.2,686.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M97.8,685.6c0.6-14.3,7.3-25.8,14.9-25.4l-2.4,52.2C102.7,711.9,97.2,700,97.8,685.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.1,811.4c6.3-9.8,7-20.6,1.5-24.1s-15,1.7-21.3,11.5s-7,20.6-1.5,24.1 C121.3,826.4,130.8,821.2,137.1,811.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M117.5,798.7c-6.2,9.6-6.9,20.1-1.9,23.8l23-35.2l-1.4-0.6C131.8,784.6,123.2,789.6,117.5,798.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M101.7,848.5L82.1,726.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.9,743.3c6.7-1.1,10.5-12.4,8.5-25.2c-2.1-12.8-9.2-22.4-15.9-21.3C69.8,697.9,66,709.2,68,722 C70.1,734.8,77.2,744.4,83.9,743.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M68,722c-2-12.8,1.8-24.2,8.4-25.3l7.4,46.6C77.2,744.5,70,735,68,722z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M93,891.9h23.5c1,0,2.1-0.2,3-0.6c1-0.4,1.8-1,2.6-1.7c0.7-0.7,1.3-1.6,1.7-2.6c0.4-1,0.6-2,0.6-3v-31.2H84.9 V884c0,2.1,0.9,4.2,2.4,5.7C88.9,891.1,90.9,891.9,93,891.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M125.5,848.5H84.2c-0.5,0-1.1,0.3-1.4,0.7c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.5,0.2,1.1,0.6,1.5s0.9,0.6,1.4,0.7 h41.3c0.3,0,0.6-0.1,0.8-0.2c0.3-0.1,0.5-0.3,0.7-0.5s0.4-0.4,0.5-0.7c0.1-0.3,0.2-0.5,0.2-0.8c0-0.6-0.3-1.1-0.7-1.5 C126.6,848.8,126.1,848.6,125.5,848.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M124.6,852.7h-36c-0.6,0-1.1-0.2-1.5-0.6s-0.6-0.9-0.6-1.5s0.2-1.1,0.6-1.5s0.9-0.6,1.5-0.6h-4.4 c-0.6,0-1.1,0.2-1.5,0.6s-0.6,0.9-0.6,1.5s0.2,1.1,0.6,1.5c0.4,0.4,0.9,0.6,1.5,0.6h0.9v31.1c0,1,0.2,2.1,0.6,3 c0.4,1,1,1.8,1.7,2.6c0.7,0.7,1.6,1.3,2.6,1.7c1,0.4,2,0.6,3,0.6h12.8c-2.7,0-5.3-0.9-7.4-2.6s-3.5-4.1-4-6.8l-5.7-29.1h35.9V852.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1140.5,406.4l61.7,18.2c-1.1,25.7-8.4,50.7-21.4,72.8l-61.7-18.2C1132,457,1139.3,432,1140.5,406.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1146.5,417.6l44.9,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1146.5,423.6l44.9,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1158.9,433.3l31.5,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1145.5,429.6l10.5,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1144.5,435.6l44.9,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1177.4,450.8l11,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1158.9,445.8l15.7,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1143.5,441.6l12.5,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1141.5,447.6l44.9,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1157.4,458.5l27,7.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1139.5,453.6l14.3,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1136.5,459.6l44.9,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1148.9,469.8l29.5,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1133.5,465.6l10,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1130.5,471.6l44.9,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M667,106.8l-55.9,15.3c-0.3-8.7-2-17.4-5-25.6c-4.2-11.3-9.2-16.8-12.3-29.8c-1.2-4.9-1.8-9.9-2-15l55.9-15.3 c-0.2,5.1,0.1,10.2,1.1,15.3c2.2,11.6,6.5,17.7,10.8,28.1C663.2,88.5,665.6,97.5,667,106.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M602.1,58l37-10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M602,65.2l37-10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M605.8,71.5l37-10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M622.7,73l23.5-6.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M609.3,76.7l10.3-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M611.9,82.2l37-10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M641.3,80.4l10-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M614.4,87.8l23.3-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M642.9,86.2l10-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M627.5,90.4l12.7-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M616,93.5l8.4-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M618.5,99.1l37-10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M626.8,103l29.3-8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M619.2,105.1l5.6-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M619.8,111.2l37-10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M52.6,464.7l57.5,7.7c-0.9-8.7-0.4-17.5,1.5-26c2.6-11.7,6.9-17.9,8.2-31.2c0.5-5,0.5-10.1,0-15.1l-57.5-7.7 c0.9,5,1.2,10.2,1,15.3c-0.6,11.8-4.1,18.4-7,29.3C54,446,52.7,455.3,52.6,464.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M109.4,407.6l-38-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M110.5,414.8l-38-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M107.5,421.5l-38-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M91,425.3L66.8,422"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M104.8,427.1l-10.6-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M103,432.9l-38-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M73.5,435l-10.3-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M101.2,438.8l-23.9-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M72.7,441l-10.3-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M88.6,443.1l-13.1-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M100.4,444.7l-8.6-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M98.6,450.5l-38-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M90.9,455.5l-30.1-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M98.8,456.6l-5.8-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M99,462.7l-38-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M924.1,397.2c0.3-3,0.5-6,0.8-9.1C924.6,391.2,924.4,394.2,924.1,397.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M930.7,315.8c0.2-2.5,0.4-5,0.5-7.5C931.2,310.8,931,313.2,930.7,315.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M926.8,365.8c0.2-3,0.5-5.9,0.7-8.8C927.4,359.9,927.1,362.8,926.8,365.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M917.5,463.1c0.5-4.1,0.9-8.3,1.4-12.6C918.4,454.8,918,459,917.5,463.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M930,327.5c0.3-4,0.6-7.9,0.9-11.7C930.6,319.6,930.2,323.5,930,327.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M928.6,344.1c0.2-2.8,0.4-5.6,0.7-8.4C929.1,338.4,928.8,341.2,928.6,344.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M983.6,311.5c1.4-29.5-1.6-50.1-1.6-50.1h0.1l-3.2-1.4l-4.1,0.9l-27.8,6.2l-8.9-13l-3.8-0.4l3.2,0.4 c0.4,15.5,8.8,109.2-7.8,228.8h53.8c-7.1-53.8-3.1-112.4-1.5-156.6L983.6,311.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M919.7,441.9c0.3-2.9,0.6-5.8,0.9-8.8C920.4,436.1,920.1,439,919.7,441.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M922,419.8c0.4-4.5,0.9-9,1.3-13.5C922.8,410.8,922.4,415.3,922,419.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M920.6,433.2c0.3-2.9,0.6-5.9,0.9-8.9C921.2,427.2,921,430.2,920.6,433.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M926.1,374.7c0.3-3,0.5-6,0.8-8.9C926.6,368.7,926.4,371.7,926.1,374.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M924.8,388.2l1.2-13.5C925.6,379.1,925.2,383.6,924.8,388.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M937.6,254.1l-3.2-0.4c0.1,5.7-1,26.5-3,54.5c-0.2,2.4-0.4,4.9-0.5,7.5c-0.3,3.8-0.6,7.7-0.9,11.7 c-0.2,2.7-0.4,5.4-0.6,8.2s-0.4,5.5-0.7,8.4c-0.3,4.2-0.7,8.5-1,12.9c-0.2,2.9-0.5,5.8-0.7,8.8s-0.5,5.9-0.8,8.9l-1.2,13.5 c-0.3,3-0.5,6-0.8,9.1s-0.6,6-0.8,9.1c-0.4,4.5-0.9,9-1.3,13.5c-0.1,1.5-0.3,3-0.4,4.5c-0.3,3-0.6,5.9-0.9,8.9s-0.6,5.9-0.9,8.8 c-0.3,2.9-0.6,5.8-0.9,8.6c-0.5,4.3-0.9,8.5-1.4,12.6c-0.8,6.9-1.5,13.5-2.3,19.8h14.6C946.4,363.4,938,269.6,937.6,254.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M934.8,264.3l-0.5-10.5c0.1,5.7-1,26.5-3,54.5c-0.2,2.4-0.4,4.9-0.5,7.5c-0.3,3.8-0.6,7.7-0.9,11.7 c-0.2,2.7-0.4,5.4-0.6,8.2s-0.4,5.5-0.7,8.4c-0.3,4.2-0.7,8.5-1,12.9c-0.2,2.9-0.5,5.8-0.7,8.8s-0.5,5.9-0.8,8.9l-1.2,13.5 c-0.3,3-0.5,6-0.8,9.1s-0.6,6-0.8,9.1c-0.4,4.5-0.9,9-1.3,13.5c-0.1,1.5-0.3,3-0.4,4.5c-0.3,3-0.6,5.9-0.9,8.9s-0.6,5.9-0.9,8.8 c-0.3,2.9-0.6,5.8-0.9,8.6c-0.5,4.3-0.9,8.5-1.4,12.6c-0.8,6.9-1.5,13.5-2.3,19.8h14.6C946.4,363.4,935.2,279.7,934.8,264.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M885,472.9l7.4,366.4h33.5l18.7-310c0.1-1.7,0.9-3.4,2.2-4.6c1.3-1.2,2.9-1.8,4.7-1.8c1.7,0,3.4,0.7,4.7,1.9 c1.2,1.2,2,2.9,2.1,4.6l17,309.9h33.5l10.3-366.4H885z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M893.2,482.9l-1.6,36.4h22c2.8,0.1,5.6-0.9,7.8-2.7c2.2-1.8,3.7-4.3,4.2-7c1.5-9,2.8-27.9,4.1-36.6h-36.5 V482.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M895.8,860.3l-0.9-29.2h28.4l-1.3,30.1L895.8,860.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M923.1,839.3l-0.9,21.9l-6.8-0.2l0.2-12.9c0-1-0.3-2-0.9-2.8s-1.5-1.4-2.5-1.6l-17-4.4H923.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M922.1,886.7v-25.5c0-3.7-1.5-7.3-4.1-9.9s-6.2-4.1-9.9-4.1h-0.6c-3.1,0-6,1-8.4,3c-2.4,1.9-4,4.6-4.6,7.6 c-0.7,3.7-2.4,7.1-4.8,9.9l-4,4.7c-3.4,4-5.3,9.1-5.3,14.3H922.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M898,860.8c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1-0.3-0.1-0.6,0.2-0.7c2.3-1.3,5-2,7.7-2 s5.4,0.7,7.7,2c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.3-0.1,0.4s-0.2,0.2-0.3,0.2c-0.1,0-0.3,0-0.4-0.1c-2.2-1.2-4.6-1.9-7.2-1.9 s-5,0.7-7.2,1.9C898.2,860.8,898.1,860.8,898,860.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M896.2,864.4c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1-0.3-0.1-0.6,0.2-0.7c2.3-1.3,5-2,7.7-2 s5.3,0.7,7.7,2c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.3-0.1,0.4s-0.2,0.2-0.3,0.2c-0.1,0-0.3,0-0.4-0.1c-2.2-1.2-4.6-1.9-7.2-1.9 s-5,0.7-7.1,1.9C896.5,864.4,896.4,864.4,896.2,864.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M894.5,868.2c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1-0.3-0.1-0.6,0.2-0.7c2.3-1.3,5-2,7.7-2 s5.4,0.7,7.7,2c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.3-0.1,0.4s-0.2,0.2-0.3,0.2c-0.1,0-0.3,0-0.4-0.1c-2.2-1.2-4.6-1.9-7.2-1.9 s-5,0.6-7.2,1.9C894.6,868.2,894.5,868.2,894.5,868.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M882.2,892h38.1c0.2,0,0.5,0,0.7-0.1s0.4-0.2,0.6-0.4c0.2-0.2,0.3-0.4,0.4-0.6s0.1-0.4,0.1-0.7v-3.4h-41.7 v3.4c0,0.5,0.2,0.9,0.5,1.3C881.2,891.7,881.7,892,882.2,892z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M891.6,839.3l-0.3-11.6h36l-0.7,11.6H891.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M927.4,827.7l-0.7,11.6h-35l-0.3-11.6L927.4,827.7L927.4,827.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M927.4,827.7l-0.7,11.6h-35l-0.3-11.6L927.4,827.7L927.4,827.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1054.1,308.1c-1.2-5.3-3.6-10.3-7.1-14.5s-7.9-7.5-12.8-9.7l-52.1-22.6H982c0.1,0.5,0.1,1.1,0,1.6 s-0.2,1.1-0.3,1.6c-0.6,6.7-1.9,23.2-2.9,45.5c-0.2,4.4-0.4,9.1-0.6,14c-1.5,42-1.7,131.7,4.3,186.7c0.2,2.3,1.3,4.4,3.1,5.9 s3.9,2.4,6.2,2.4h27l1.6-75.7l1.6-76.8l1.3,4.7l42.2-9.9L1054.1,308.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1022.4,365.8l-9.4-31.7c-0.1-0.2-0.2-0.4-0.4-0.5c-0.2-0.1-0.4-0.2-0.7-0.1c-0.2,0-0.4,0.1-0.6,0.3 s-0.3,0.4-0.3,0.6l-13.5,183.5c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3s0.2,0.2,0.3,0.2c0.1,0.1,0.3,0.1,0.4,0.1h19 c0.3,0,0.5-0.1,0.7-0.3s0.3-0.4,0.3-0.7l4-151.9C1022.5,366,1022.4,365.9,1022.4,365.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M975.5,217l-1-4.6c-2.6-31.6-43.1-4.5-43.1-4.5s1.4,11.2,2.2,23.6c0,2.7,2.4,4.6,2.9,6.7v8.8l-0.8,17 c0,0,6.7,8.9,21.7,8.9c0,0,16,0,25-12L975.5,217z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M934.4,253.3l-20.3,3.6c-8.2,1.5-16.4,2.5-24.7,3.4c-9.6,0.9-16.9,2.4-25.7,5.9l-1.2,1.4v52l13.8-3.1l1.6,12.4 c6.6,49.8,8.8,90.1,6.5,140.4l-2.2,49.7h22c2.8,0,5.5-0.9,7.7-2.7s3.7-4.2,4.3-7C935.2,419,934.7,268.7,934.4,253.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M934.2,286l2.2-36.1l-9.3,5.1l-14.8,35L934.2,286z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M913.2,289.3l13.9-34.3l-1.3,0.8l-14.4,34.9l22.6,1.9l0.2-6.6L913.2,289.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M981.1,254.6l7.7,9.7l8.7,37.3l-17.3-9.8l1.6-25.6l0.1-0.5c0.3-1.4,0.4-2.8,0.3-4.2L981.1,254.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M990.2,264.9l-1.6-0.6L997,301l-17-9.3l-0.6,7.6l19.2,3.6L990.2,264.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M862.4,303.9l0.3,15.8l13.4-3l-2-11.4c-0.1-0.7-0.4-1.3-0.8-1.9s-0.9-1.1-1.5-1.4c-0.6-0.4-1.3-0.6-2-0.6 c-0.7-0.1-1.4,0-2.1,0.2L862.4,303.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M951.4,522.9c-1.7,0-3.4,0.7-4.7,1.8c-1.3,1.2-2,2.8-2.1,4.6l-18,298.4h-10.7l4.3-285c0.1-5.3,2.2-10.3,6-14 s8.8-5.8,14.1-5.8L951.4,522.9L951.4,522.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M926.6,839.3l0.7-11.6h-11.5l-0.2,11.6H926.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M1018,519.3l-9.3,320h-3.2l0.3-8.2h-12.4l4.4-311.8H1018z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1004.8,860.3l0.9-29.2h-28.5l1.3,30.1L1004.8,860.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1005.5,839.3l-0.6,21l-11.9,0.4l0.2-14.2c0-0.7-0.2-1.3-0.6-1.8s-0.9-0.9-1.5-1.2l-13.4-4.3L1005.5,839.3 L1005.5,839.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M978.6,886.7v-25.5c0-3.7,1.5-7.3,4.1-9.9s6.2-4.1,9.9-4.1h0.6c3.1,0,6,1,8.4,3c2.4,1.9,4,4.6,4.6,7.6 c0.7,3.7,2.4,7.1,4.8,9.9l4,4.7c3.4,4,5.3,9.1,5.3,14.3H978.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1002.7,860.8c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1-0.1c-2.2-1.3-4.6-1.9-7.2-1.9c-2.5,0-5,0.7-7.2,1.9 c-0.1,0-0.1,0.1-0.2,0.1s-0.1,0-0.2,0s-0.1,0-0.2-0.1l-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2s0-0.1,0-0.2s0-0.1,0.1-0.2l0.1-0.1 c2.3-1.3,5-2.1,7.7-2.1s5.4,0.7,7.7,2.1c0.3,0.1,0.3,0.5,0.2,0.7C1003,860.7,1002.9,860.7,1002.7,860.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1004.4,864.4c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1-0.1c-2.2-1.3-4.6-1.9-7.1-1.9s-5,0.7-7.2,1.9 c-0.1,0-0.1,0.1-0.2,0.1s-0.1,0-0.2,0s-0.1,0-0.2-0.1l-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2s0-0.1,0-0.2s0-0.1,0.1-0.2 c0-0.1,0.1-0.1,0.1-0.1c2.3-1.4,5-2.1,7.7-2.1s5.4,0.7,7.7,2.1c0.3,0.1,0.3,0.5,0.2,0.7S1004.6,864.4,1004.4,864.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1006.2,868.2c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1-0.1c-2.2-1.3-4.6-2-7.2-2c-2.5,0-5,0.7-7.2,2 c-0.1,0-0.1,0.1-0.2,0.1s-0.1,0-0.2,0s-0.1,0-0.2-0.1l-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2s0-0.1,0-0.2s0-0.1,0.1-0.2 c0-0.1,0.1-0.1,0.1-0.1c2.3-1.3,5-2.1,7.7-2.1s5.4,0.7,7.7,2.1c0.3,0.1,0.3,0.5,0.2,0.7c-0.1,0.1-0.1,0.1-0.2,0.1 C1006.4,868.1,1006.3,868.2,1006.2,868.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1018.5,892h-38.1c-0.2,0-0.5,0-0.7-0.1s-0.4-0.2-0.6-0.4c-0.2-0.2-0.3-0.4-0.4-0.6s-0.1-0.4-0.1-0.7v-3.4 h41.8v3.4c0,0.5-0.2,1-0.6,1.3C1019.4,891.8,1019,892,1018.5,892z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M973.6,827.7l0.7,11.6h35l0.2-11.6L973.6,827.7L973.6,827.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M973.6,827.7l0.7,11.6h35l0.2-11.6L973.6,827.7L973.6,827.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M993.4,827.7v11.6h16l0.2-11.6L993.4,827.7L993.4,827.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M923.1,210.7c-3.3-0.1-6.5-1.6-8.8-4.1s-3.5-5.7-3.3-9.1c0.1-3.3,1.6-6.5,4-8.8s5.7-3.5,9.1-3.4 c0.4,0,1.4-0.2,1.3,0.1C922.6,196.5,925.9,210.7,923.1,210.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M925.3,170.8c0,0-14.4,74.5,19.9,78.1c29.8,3.1,31.7-43.3,31.7-43.3l-2.3-29.9l-23.1-8.4L925.3,170.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M935.1,188.6c3.5-4.9,9.2-8.4,15.3-8.3c6.9,0.1,12.5,5.6,11.9,13.7l-0.1,1.8c-0.1,0.8,0.2,1.6,0.7,2.2 s1.3,1,2.1,1.1c0.8,0,1.5,0.2,2.2,0.5s1.3,0.7,1.8,1.3c0.5,0.5,0.9,1.2,1.2,1.9c0.3,0.7,0.4,1.5,0.4,2.2l-0.1,5.2 c0,0.2,0,0.3,0.1,0.4s0.2,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0.1,0.3,0.1,0.4,0.1c0,0,1.5,0.2,1.8-1l0.8-5.6l-5.4-31.7 l-26.3-6.9l-11,9.3L935.1,188.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M975.5,217.1c0,0-2.1-0.1-3.7-2.8l4.1,7L975.5,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M938.3,229l13.7-3.2c0.1,1.6-0.4,3.1-1.3,4.4s-2.3,2.2-3.8,2.5C940.4,234.4,938.3,229,938.3,229z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M950.5,211.4c0.6,0,1.1-0.2,1.6-0.5s0.8-0.7,1-1.3c0.2-0.5,0.3-1.1,0.2-1.6c-0.1-0.5-0.4-1.1-0.8-1.4 c-0.4-0.4-0.9-0.7-1.4-0.8c-0.5-0.1-1.1-0.1-1.6,0.2c-0.5,0.2-0.9,0.6-1.3,1c-0.3,0.5-0.5,1-0.5,1.6c0,0.4,0.1,0.7,0.2,1.1 c0.1,0.3,0.3,0.7,0.6,0.9s0.6,0.5,0.9,0.6C949.7,211.3,950.1,211.4,950.5,211.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M949.2,208.3c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.1,0.2-0.2s0.1-0.2,0-0.3s-0.1-0.2-0.1-0.3 c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0.1-0.2,0.2c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.3,0.2,0.4 C948.9,208.2,949.1,208.3,949.2,208.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M928.6,212.1c0.6,0,1.1-0.2,1.6-0.5s0.8-0.7,1-1.3c0.2-0.5,0.3-1.1,0.2-1.6c-0.1-0.5-0.4-1-0.8-1.4 s-0.9-0.7-1.4-0.8c-0.6-0.1-1.1-0.1-1.6,0.2c-0.5,0.2-0.9,0.6-1.3,1c-0.3,0.5-0.5,1-0.5,1.6c0,0.7,0.3,1.5,0.8,2 C927.1,211.8,927.8,212.1,928.6,212.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M927.5,208.9c0.1,0,0.1,0,0.2,0s0.1-0.1,0.2-0.1c0,0,0.1-0.1,0.1-0.2s0-0.1,0-0.2s0-0.2-0.1-0.3 c-0.1-0.1-0.1-0.2-0.2-0.2s-0.2-0.1-0.3,0c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0,0.3 c0,0.1,0.1,0.2,0.2,0.2C927.2,208.9,927.3,208.9,927.5,208.9z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M938.6,224.8l3.6,0.1c0.2,0,0.4-0.1,0.6-0.2s0.3-0.3,0.3-0.6c0-0.2-0.1-0.4-0.2-0.6s-0.3-0.3-0.6-0.3 l-3.6-0.1c-0.9-0.1-1.7-0.9-1.5-1.7c0.1-0.8,0.9-1.7,1.7-1.5c0.2,0,0.4-0.1,0.6-0.2s0.3-0.3,0.3-0.5c0.1-0.4-0.4-0.8-0.8-0.9 c-0.9,0-1.7,0.3-2.3,0.9c-0.7,0.6-1,1.4-1.1,2.2c0,0.4,0,0.9,0.2,1.3c0.1,0.4,0.3,0.8,0.6,1.1c0.3,0.3,0.6,0.6,1,0.8 C937.7,224.7,938.2,224.8,938.6,224.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M916.7,206.5l0.1,3.1c0.1,2.9,1.3,5.5,3.4,7.5s4.9,3,7.7,2.9c2.8-0.1,5.6-1.3,7.5-3.4c2-2.1,3-4.8,3-7.7 l-0.1-3.1c0-0.4-0.1-0.9-0.2-1.3c-0.2-0.4-0.4-0.8-0.7-1.1l4.2-0.1c-0.3,0.3-0.5,0.7-0.6,1.1s-0.2,0.9-0.1,1.3l0.1,3.1 c0.1,2.9,1.3,5.6,3.4,7.5c2.1,2,4.9,3,7.7,2.9c2.9-0.1,5.6-1.3,7.5-3.4c2-2.1,3-4.9,2.9-7.7l-0.1-3.1c0-1-0.5-2-1.3-2.8 c-0.8-0.7-1.8-1.1-2.8-1.1l-13.6,0.4h-0.1l-10.5,0.3h-1.7l-12,0.4c-1.1,0.1-2,0.6-2.8,1.4C917.1,204.4,916.7,205.4,916.7,206.5z  M944.6,203.3l13.7-0.4c0.6,0,1.2,0.2,1.7,0.7c0.4,0.4,0.7,1,0.8,1.6l0.1,3.1c0,1.2-0.1,2.4-0.6,3.6c-0.4,1.1-1.1,2.2-1.9,3.1 s-1.8,1.6-2.9,2.1s-2.3,0.8-3.5,0.8s-2.4-0.2-3.6-0.6c-1.1-0.4-2.2-1.1-3.1-2c-0.9-0.8-1.6-1.9-2.1-3s-0.7-2.3-0.8-3.6l-0.1-3.1 c0-0.6,0.3-1.2,0.7-1.6C943.4,203.7,944,203.4,944.6,203.3z M918.2,206.5c0-0.6,0.2-1.2,0.7-1.7c0.4-0.5,1-0.7,1.6-0.7l12-0.4h1.7 c0.6,0,1.2,0.2,1.7,0.7c0.4,0.4,0.7,1,0.8,1.6l0.1,3.1c0.1,1.2-0.1,2.4-0.6,3.6c-0.4,1.1-1.1,2.2-1.9,3.1s-1.8,1.6-3,2.1 c-1.1,0.5-2.3,0.8-3.5,0.8s-2.4-0.2-3.6-0.6c-1.1-0.4-2.2-1.1-3.1-2c-0.9-0.8-1.6-1.9-2.1-3s-0.7-2.3-0.8-3.6L918.2,206.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M983.6,184.9c-1-8-5.2-14.1-12.3-15.6c-3-0.6-6.1-0.5-9,0.4c-0.3,0.1-0.5,0.1-0.8,0.1s-0.5-0.1-0.8-0.2 c-0.2-0.1-0.4-0.3-0.6-0.5s-0.3-0.5-0.4-0.7c-0.7-2.7-2.2-5-4.3-6.7c-2.2-1.7-4.8-2.6-7.6-2.6c-1.9,0-3.8,0.4-5.5,1.3 s-3.2,2.1-4.3,3.7c-0.2,0.2-0.4,0.4-0.6,0.6s-0.5,0.2-0.8,0.3c-0.3,0-0.6,0-0.8-0.1c-0.3-0.1-0.5-0.2-0.7-0.4c0,0-8.2-6.5-18.9,0.1 c-3.6,2.4-6.2,6-7.3,10.2c-1.1,4.2-0.6,8.6,1.3,12.5c4.3,8.6,15.6,11.1,22.5,4.6c2.4-2.3,4.3-5.8,4.7-10.9c0.3-2.8,0.1-5.7-0.8-8.4 h3.6c4.2-0.2,10.9-1,17.1-0.1c-0.1,0.1-0.2,0.1-0.4,0.3l11.1,3.7c0,0,3.4,29.4,5.2,29.2C981.2,203.7,984.6,192.2,983.6,184.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M974.2,202.1c0,0,1.2-5.5,7-3.8c6.7,1.9,5.5,15.3-3.3,18.4c-5.5,1.1-4.7-2.2-4.3-6.7L974.2,202.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M982.1,202c-0.5-0.3-1-0.5-1.6-0.6c-0.5-0.1-1.1,0-1.6,0.2s-0.9,0.5-1.3,0.9s-0.7,0.8-0.9,1.3 c-0.6,1.3-0.8,2.6-0.5,4v1.1c0,0.2,0.1,0.3,0.3,0.4c0.1,0.1,0.3,0.1,0.5,0.1s0.3-0.1,0.4-0.3c0.1-0.1,0.1-0.3,0.1-0.5v-1.1 c-0.1-1.1,0-2.2,0.4-3.3c0.3-0.7,0.8-1.2,1.4-1.5c0.7-0.1,1.4,0,2,0.3c0.2,0.1,0.3,0.1,0.5,0c0.2,0,0.3-0.1,0.4-0.3 C982.4,202.7,982.3,202.3,982.1,202z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M967.3,241.5c-3.9,4.9-9.5,8.1-15.7,9c-4.5,3.2-10,4.9-15.6,4.8l0.4-9.3l1.3,0.7c4.7,2.4,10.2,3.1,15.3,2 c5.2-1.1,9.8-4,13.1-8.2c0.1-0.3,0.7-0.3,1-0.1c0.1,0.2,0.2,0.3,0.2,0.5C967.4,241.1,967.4,241.3,967.3,241.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1009.6,568c-0.4,0-0.8,0-1.2,0c-6.4-0.3-12.6-4.6-18.6-12.8l-0.6-0.8c-2-2.8-4.1-5.6-6.2-8.4l-62-80.5 c-0.3-0.4-0.6-0.8-0.8-1.3s-0.2-1-0.2-1.5c0.1-0.5,0.2-1,0.5-1.5s0.6-0.9,1-1.2s0.9-0.5,1.4-0.7c0.5-0.1,1-0.2,1.5-0.1 c0.5,0.1,1,0.3,1.4,0.5c0.4,0.3,0.8,0.6,1.1,1.1l62,80.5c2.2,2.8,4.3,5.7,6.3,8.5l0.6,0.8c4.4,6.1,8.8,9.4,12.7,9.7 c1,0.1,1.9-0.1,2.8-0.4s1.7-0.8,2.4-1.5c0.3-0.4,0.7-0.7,1.2-0.9c0.4-0.2,0.9-0.3,1.4-0.4s1,0.1,1.5,0.2c0.5,0.2,0.9,0.4,1.3,0.8 c0.7,0.7,1.2,1.6,1.2,2.6s-0.3,2-1,2.7C1016.8,566.4,1013.3,567.9,1009.6,568z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.2,250.4c-0.2,0-0.4,0-0.5-0.1c-0.2-0.1-0.3-0.2-0.4-0.3l-7.8-8.2c-0.2-0.2-0.3-0.6-0.3-0.9s0.2-0.6,0.4-0.9 c0.2-0.2,0.6-0.4,0.9-0.3c0.3,0,0.6,0.1,0.9,0.4l7.8,8.2c0.2,0.2,0.3,0.4,0.3,0.6s0,0.5-0.1,0.7s-0.2,0.4-0.5,0.6 C795.7,250.3,795.4,250.4,795.2,250.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1048.3,538.7L964,427.5l-35.9,26.8l86.1,110.6c1.8,2.3,4,4.2,6.5,5.5c2.5,1.4,5.3,2.3,8.1,2.6 c2.8,0.3,5.7,0.1,8.5-0.8c2.8-0.8,5.3-2.2,7.5-4c4.3-3.5,7-8.6,7.7-14.1C1053.1,548.7,1051.6,543.1,1048.3,538.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1048.3,538.7L964,427.5l-35.9,26.8l86.1,110.6c1.8,2.3,4,4.2,6.5,5.5c2.5,1.4,5.3,2.3,8.1,2.6 c2.8,0.3,5.7,0.1,8.5-0.8c2.8-0.8,5.3-2.2,7.5-4c4.3-3.5,7-8.6,7.7-14.1C1053.1,548.7,1051.6,543.1,1048.3,538.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M960.3,422.8l4,4.6l-36.4,27.3L798.4,271.9c-4.1-5.8-6.2-12.8-5.7-19.8c0.1-2,0.5-3.7,1.5-4.6 c0.7-0.5,1.5-0.8,2.4-0.8c3.3-0.1,6.6,0.5,9.6,1.9c3,1.3,5.7,3.4,7.8,5.9L960.3,422.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M960.3,422.8l4,4.6l-36.4,27.3L798.4,271.9c-4.1-5.8-6.2-12.8-5.7-19.8c0.1-2,0.5-3.7,1.5-4.6 c0.7-0.5,1.5-0.8,2.4-0.8c3.3-0.1,6.6,0.5,9.6,1.9c3,1.3,5.7,3.4,7.8,5.9L960.3,422.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M874.8,324.3l85.5,98.5L874.8,324.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M871.5,320.5l3.3,3.8L871.5,320.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M923.9,448.9l35.3-27l4.8,5.2l-36.2,27.2L923.9,448.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M903.2,413.6c-2,0.3-3.6,1-3.9,2c-0.5,1.8,1.7,3.1,4.8,3.3c1.3,0.1,2.3,0.1,2.3,0.1l-1.6,0.1 c-0.5,0-0.9,0.1-1.3,0.3s-0.8,0.5-1.1,0.9c-1.3,1.9,0.9,3.5,3,3.7c2,0,4,0.2,6,0.4l-3.1-0.3c-0.4-0.1-0.8,0-1.2,0.1s-0.7,0.3-1,0.6 c-1.4,1.4-0.2,3.1,3.2,4.2c2.1,0.6,4.3,0.9,6.4,0.8l-2.5,0.2c-0.8,0-1.6,0.2-2.3,0.6c-1.9,1.1-1.7,2.6,2.4,3.4 c4.3,0.9,39.8-0.1,52.4-2.4l93.5-10.2c2.4-0.2,4.8-1,6.8-2.2c2.1-1.2,3.9-2.9,5.3-4.8c1.4-2,2.4-4.2,2.9-6.6 c0.5-2.4,0.5-4.8-0.1-7.2l-8.5-39.1l-42.2,9.9l8.4,21.7l-70.6,18.7l-3.9,0.8c-1.3,0.3-2.5,0.4-3.4-0.5l-0.5-0.4 c-1-1-2.1-1.9-3.3-2.5c-0.8-0.4-1.7-0.8-2.6-1l-14.7-5.5c-1.2-0.5-2.5-0.8-3.8-1c-3.8-0.9-7.5-2.2-11-4.1c-0.4-0.2-0.9-0.4-1.4-0.4 s-1,0-1.5,0.2c-0.3,0.1-0.5,0.3-0.7,0.5c-0.4,0.6-0.3,2.8,0.5,4.5c0.5,1,1.2,1.8,2.2,2.3c4.6,2.3,9.4,4.4,14.2,6.2 C921.1,413.6,903.2,413.6,903.2,413.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M913.4,432.9c5,0,28.6,0,38-3.6c5.1-1.9,10.4-3.3,15.8-4.2c20.4-3.4,73.5-12.4,87.8-15.6 c1-0.2,1.9-0.6,2.8-1.2c0.8-0.6,1.5-1.3,2.1-2.2c0.5-0.9,0.9-1.8,1.1-2.8s0.1-2-0.1-3l-8.2-35.6l13.3-3.1l8.5,39.1 c0.5,2.4,0.4,4.8-0.1,7.2s-1.5,4.6-2.9,6.5c-1.4,2-3.2,3.6-5.3,4.8c-2.1,1.2-4.4,2-6.8,2.3l-93.5,10.2c-16.5,2-49.5,3.2-52.5,2.2 c0,0-3.2-0.2-3.6-2.1C910.8,432.5,912.1,432.9,913.4,432.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M961.4,412l3.7,20l6.3-0.7l-3.7-20.7L961.4,412z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M966.6,428.7c1.2,0,2.5-0.4,3.5-1.1c1-0.7,1.8-1.7,2.3-2.8c0.5-1.2,0.6-2.4,0.4-3.6c-0.2-1.2-0.8-2.3-1.7-3.2 c-0.9-0.9-2-1.5-3.2-1.7s-2.5-0.1-3.6,0.4s-2.1,1.3-2.8,2.3c-0.7,1-1.1,2.3-1.1,3.5c0,1.7,0.7,3.3,1.8,4.5 C963.4,428,965,428.7,966.6,428.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M966.6,427.7c1.1,0,2.1-0.3,2.9-0.9c0.9-0.6,1.6-1.4,2-2.4s0.5-2,0.3-3.1c-0.2-1-0.7-2-1.4-2.7 c-0.7-0.7-1.7-1.2-2.7-1.5c-1-0.2-2.1-0.1-3.1,0.3c-1,0.4-1.8,1.1-2.4,2s-0.9,1.9-0.9,2.9c0,1.4,0.6,2.8,1.6,3.7 C963.9,427.1,965.2,427.7,966.6,427.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M970.2,422.9l-3.6-0.2l-2.6-1.9c-0.1-0.1-0.2-0.3-0.1-0.4c0.1-0.1,0.3-0.2,0.4-0.1l2.4,1.8l3.4,0.2h0.1 c0,0,0.1,0,0.1,0.1l0.1,0.1v0.1C970.5,422.7,970.4,422.9,970.2,422.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M906.6,419c0,0,12.2,0.5,20.2-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M908.9,424.4c0,0,13,0,20-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M915.4,429.7c5.2-0.2,10.4-0.6,15.5-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1178,671.5h-108c-0.9,0-1.7-0.4-2.4-1c-0.6-0.6-1-1.5-1-2.4s0.3-1.7,1-2.4c0.6-0.6,1.5-1,2.4-1h108 c0.4,0,0.9,0.1,1.3,0.2c0.4,0.2,0.8,0.4,1.1,0.7c0.3,0.3,0.6,0.7,0.7,1.1c0.2,0.4,0.2,0.8,0.2,1.3c0,0.9-0.4,1.7-1,2.4 C1179.7,671.2,1178.9,671.5,1178,671.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1173.5,671.5l17.9,220.4h-3.6l-26.9-220.4H1173.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1073.9,671.5l-18,220.4h3.6l26.9-220.4H1073.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1073.9,671.5l-0.5,4.2h6.2L1058,891.8h1.5l26.9-220.4L1073.9,671.5L1073.9,671.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1178.4,756h-3.2l-14.3-84.4h12.6l17.9,220.3h-1.8L1178.4,756z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1116,671.5l2.8,220.4h3.6l6.2-220.4H1116z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M1112.5,661.5h-48.7v3.4h48.7V661.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M1112.5,644.7h-48.7v20.2h48.7V644.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M1063.8,644.7H1180v20.2h-67.5v-16.8h-48.7V644.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M1063.8,644.7H1180v20.2h-67.5v-16.8h-48.7V644.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M1112.5,661.5h-48.7v3.4h48.7V661.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M1152.3,651.7h-28.5v7.2h28.5V651.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M1159.4,654.8c0-1.2,0.3-2.3,1-3.3s1.6-1.7,2.7-2.2c1.1-0.4,2.3-0.6,3.4-0.3s2.2,0.8,3,1.6s1.4,1.9,1.6,3 s0.1,2.3-0.3,3.4c-0.5,1.1-1.2,2-2.2,2.7s-2.1,1-3.3,1c-1.6,0-3.1-0.6-4.2-1.7S1159.4,656.4,1159.4,654.8z M1161.4,654.8 c0,0.8,0.2,1.5,0.7,2.2c0.4,0.6,1,1.1,1.7,1.4s1.5,0.4,2.2,0.2c0.8-0.1,1.5-0.5,2-1s0.9-1.2,1.1-2s0.1-1.5-0.2-2.3 c-0.3-0.7-0.8-1.3-1.4-1.8c-0.6-0.4-1.4-0.7-2.2-0.7c-0.5,0-1,0.1-1.5,0.3s-0.9,0.5-1.3,0.8c-0.4,0.4-0.7,0.8-0.9,1.3 C1161.5,653.8,1161.4,654.3,1161.4,654.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M1120.9,627.9h-39.2v16.8h39.2V627.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M1081.7,627.9h93.6v16.8h-54.4v-14.2h-39.2V627.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M1121.7,641.4h-40v3.3h40V641.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M1081.7,627.9h93.6v16.8h-54.4v-14.2h-39.2V627.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M1120.9,641.4h-39.2v3.3h39.2V641.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M1153,633.5h-22.9v5.8h22.9V633.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M1158.7,636c0-0.9,0.3-1.9,0.8-2.7s1.3-1.4,2.1-1.8c0.9-0.4,1.8-0.5,2.8-0.3c0.9,0.2,1.8,0.6,2.4,1.3 c0.7,0.7,1.1,1.5,1.3,2.4c0.2,0.9,0.1,1.9-0.3,2.8c-0.4,0.9-1,1.6-1.8,2.1s-1.7,0.8-2.7,0.8c-1.3,0-2.5-0.5-3.4-1.4 C1159.2,638.5,1158.7,637.3,1158.7,636z M1160.3,636c0,0.6,0.2,1.2,0.5,1.8c0.4,0.5,0.8,0.9,1.4,1.2c0.6,0.2,1.2,0.3,1.8,0.2 c0.6-0.1,1.2-0.4,1.6-0.9c0.4-0.4,0.7-1,0.9-1.6c0.1-0.6,0.1-1.2-0.2-1.8s-0.6-1.1-1.2-1.4c-0.5-0.3-1.1-0.5-1.8-0.5 c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.2-0.7,0.4-1,0.7s-0.5,0.6-0.7,1C1160.4,635.2,1160.3,635.6,1160.3,636z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1175.3,643.7h-93.6v1.1h93.6V643.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationFamilienrecht);
export default __webpack_public_path__ + "static/media/Illustration_Familienrecht.9a87a527ae466648ebf75f02134e98cf.svg";
export { ForwardRef as ReactComponent };